<template>
  <div class="basicPortContent">
    <Breadcrumb :matched="$route.matched" />
    <el-tabs v-model="activetab">
      <el-tab-pane
        :label="
          `第三方接口调用记录` + (thridlogsCount ? `(${thridlogsCount})` : '')
        "
        name="thirdlogs"
      >
        <thirdlogs @total="value => (thridlogsCount = value)" />
      </el-tab-pane>
      <el-tab-pane
        :label="`访问记录` + (firstlogsCount ? `(${firstlogsCount})` : '')"
        name="firstlogs"
      >
        <firstlogs @total="value => (firstlogsCount = value)" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue'
import Thirdlogs from './Thirdlogs.vue'
import Firstlogs from './Fristlogs.vue'

export default {
  components: {
    Breadcrumb,
    Thirdlogs,
    Firstlogs,
  },

  data() {
    return {
      activetab: 'thirdlogs',
      firstlogsCount: 0,
      thridlogsCount: 0,
    }
  },
}
</script>

<style lang="scss" scoped>
.basicPortContent {
  padding: 20px 20px 0 20px;

  .el-tabs {
    background-color: #fff;
    padding: 10px 0 20px 0;
  }

  ::v-deep .el-tabs__item.is-active {
    color: #333;
    font-weight: bold;
  }

  ::v-deep .el-tabs__item:hover {
    color: #333;
  }

  ::v-deep .el-tabs__item {
    font-size: 13px;
  }

  ::v-deep .el-tabs__nav-scroll {
    padding-left: 20px;
  }
}
</style>
